"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMounted = void 0;
var react_1 = require("react");
/**
 * Check if the component is still mounted.
 * Does not use `useState` hook so it does not trigger additional renders.
 * This might be used to avoid the "set state on unmounted component" react warning.
 */
function useIsMounted() {
    var isMounted = react_1.useRef(false);
    react_1.useEffect(function () {
        isMounted.current = true;
        return function () { return (isMounted.current = false); };
    }, []);
    return isMounted;
}
exports.useIsMounted = useIsMounted;
//# sourceMappingURL=useIsMounted.js.map